import Vue from 'vue'
import roleApi from '@/api/role.api'


const state = {
  roles: {}
}


const getters = {
  roleById: (state) => (id) => {
    return state.roles[id]
  },

  roles: (state) => {
    return Object.values(state.roles) || []
  }
}


const actions = {
  async loadRoles ({ commit, rootState }) {
    const response = await roleApi.getRoles(rootState.tenant.current)
    commit('SET_ROLES', response.data)
  }
}


const mutations = {
  SET_ROLES (state, roles) {
    state.roles = {}
    for (const role of roles) {
      Vue.set(state.roles, role.id, role)
    }
  }
}


export default {
  state,
  getters,
  actions,
  mutations
}
